"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var ButtonGroupInput_1 = require("./ButtonGroupInput");
var CheckboxGroup_1 = require("./CheckboxGroup");
var DatetimePicker_1 = require("./DatetimePicker");
var FilePicker_1 = require("./FilePicker");
var FormLabel_1 = require("./FormLabel");
var MultiSelect_1 = require("./MultiSelect");
var Radio_1 = require("./Radio");
var Select_1 = require("./Select");
var Switch_1 = require("./Switch");
var Text_1 = require("./Text");
var Textarea_1 = require("./Textarea");
var Textfield_1 = require("./Textfield");
var TimePicker_1 = require("./TimePicker");
var FormFieldContainer = (0, react_1.styled)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    variants: {
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
});
var StyledFormField = (0, react_1.styled)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    variants: {
        inline: {
            true: (_a = {
                    flexDirection: "row",
                    alignItems: "center"
                },
                _a["& ".concat(FormLabel_1.FormLabel)] = {
                    width: "160px",
                    minWidth: "160px",
                },
                _a),
        },
        type: {
            switch: {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
            },
            select: {},
            textfield: {},
            textarea: {},
            radio: {},
            checkbox: {},
            datetime: {},
            file: {},
            number: {},
            currency: {},
            time: {},
            multiselect: {},
            buttongroup: {},
        },
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
});
var InputContainer = (0, react_1.styled)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    variants: {
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
});
var ErrorText = (0, react_1.styled)(Text_1.Text, {
    color: stitches_config_1.theme.colors.red11,
});
var MessageText = (0, react_1.styled)(Text_1.Text, {
    color: stitches_config_1.theme.colors.gray11,
});
var HintText = (0, react_1.styled)(Text_1.Text, {
    color: stitches_config_1.theme.colors.gray11,
});
function renderInput(type, props) {
    switch (type) {
        case "textarea":
            return ((0, jsx_runtime_1.jsx)(Textarea_1.Textarea, __assign({}, props, { error: !!props.errorMessage })));
        case "select":
            return (0, jsx_runtime_1.jsx)(Select_1.Select, __assign({}, props, { error: !!props.errorMessage }));
        case "textfield":
        case "number":
            return ((0, jsx_runtime_1.jsx)(Textfield_1.Textfield, __assign({}, props, { error: !!props.errorMessage })));
        case "currency":
            var type_1 = props.type, currencyProps = __rest(props, ["type"]);
            return ((0, jsx_runtime_1.jsx)(Textfield_1.CurrencyField, __assign({}, currencyProps, { error: !!currencyProps.errorMessage })));
        case "switch":
            return (0, jsx_runtime_1.jsx)(Switch_1.Switch, __assign({}, props));
        case "datetime":
            return (0, jsx_runtime_1.jsx)(DatetimePicker_1.DatetimePicker, __assign({}, props));
        case "file":
            return (0, jsx_runtime_1.jsx)(FilePicker_1.FilePicker, __assign({}, props));
        case "radio":
            return (0, jsx_runtime_1.jsx)(Radio_1.Radio, __assign({}, props));
        case "checkbox":
            return (0, jsx_runtime_1.jsx)(CheckboxGroup_1.CheckboxGroup, __assign({}, props));
        case "time":
            return (0, jsx_runtime_1.jsx)(TimePicker_1.TimePicker, __assign({}, props));
        case "multiselect":
            return (0, jsx_runtime_1.jsx)(MultiSelect_1.MultiSelect, __assign({}, props));
        case "buttongroup":
            return (0, jsx_runtime_1.jsx)(ButtonGroupInput_1.ButtonGroupInput, __assign({}, props));
    }
}
function FormField(props) {
    return ((0, jsx_runtime_1.jsxs)(FormFieldContainer, __assign({ css: props.css, fullWidth: props.fullWidth }, { children: [(0, jsx_runtime_1.jsxs)(StyledFormField, __assign({ inline: props.inline, type: props.type, fullWidth: props.fullWidth }, { children: [(0, jsx_runtime_1.jsx)(FormLabel_1.FormLabel, { tooltip: props.tooltip, text: props.label, hint: props.hint && !props.inline ? props.hint : undefined, inline: props.inline }), (0, jsx_runtime_1.jsxs)(InputContainer, __assign({ fullWidth: props.fullWidth }, { children: [renderInput(props.type, props), props.errorMessage && ((0, jsx_runtime_1.jsx)(ErrorText, __assign({ variant: "text-sm" }, { children: props.errorMessage }))), props.message && ((0, jsx_runtime_1.jsx)(MessageText, __assign({ variant: "text-sm" }, { children: props.message })))] }))] })), (0, jsx_runtime_1.jsx)("div", { children: props.hint && props.inline && ((0, jsx_runtime_1.jsx)(HintText, __assign({ variant: "text-sm" }, { children: props.hint }))) })] })));
}
exports.FormField = FormField;
//# sourceMappingURL=FormField.js.map